import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserStore } from '../store/userStore'
import { getUserProfile, logout as apiLogout } from '../api/auth'

export function useAuth() {
  const navigate = useNavigate()
  const { user, token, setUser, setToken, logout: storeLogout } = useUserStore()
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    const initAuth = async () => {
      if (!token) {
        setLoading(false)
        return
      }

      try {
        const userInfo = await getUserProfile()
        setUser(userInfo)
      } catch {
        // token 无效，清除
        storeLogout()
      } finally {
        setLoading(false)
      }
    }

    if (!user && token) {
      initAuth()
    } else {
      setLoading(false)
    }
  }, [token, user, setUser, storeLogout])

  const login = async (token: string, userInfo: typeof user) => {
    setToken(token)
    setUser(userInfo)
  }

  const logout = () => {
    apiLogout()
    storeLogout()
    navigate('/login')
  }

  return {
    user,
    token,
    isLoading,
    isAuthenticated: !!token && !!user,
    isAdmin: user?.role === 'admin' || user?.role === 'super_admin',
    login,
    logout
  }
}
